exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header{\n    background-color: #242f42;\n}\n.login-wrap{\n    background: #324157;\n}\n.plugins-tips{\n    background: #eef1f6;\n}\n.plugins-tips a{\n    color: #20a0ff;\n}\n.el-upload--text em {\n    color: #20a0ff;\n}\n.pure-button{\n    background: #20a0ff;\n}\n.tags-li.active {\n    border: 1px solid #409EFF;\n    background-color: #409EFF;\n}\n.message-title{\n    color: #20a0ff;\n}\n/* .collapse-btn:hover{\n    background: rgb(40,52,70);\n} */", ""]);

// exports
